import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Tooltip, TooltipPortal } from "@animech/ui";
import { useTranslation } from "react-i18next";
import * as Styled from "./pump-choice-select.style";
import { ChoiceColumns } from "./choice-columns";
import { AlertIcon } from "ui/components/elements/icons/alert";
import { PressureGaugeIcon } from "ui/components/elements/icons/pressure-gauge";
/**
 * Picks a pump within its family column by column — nozzle & size, size
 * (number of ejectors), functions — with a line through the picked option of
 * each column, as they make up one pump together, ending at the pump's image.
 * Every click picks a pump, so the columns always show the pump the node has.
 */
export var PumpChoiceSelect = function (_a) {
    var pumpChoice = _a.pumpChoice, feedPressureUnit = _a.feedPressureUnit;
    var t = useTranslation().t;
    var nozzleSizes = pumpChoice.nozzleSizes, ejectorCounts = pumpChoice.ejectorCounts, hasVariantColumn = pumpChoice.hasVariantColumn, variants = pumpChoice.variants, selected = pumpChoice.selected, selectedPump = pumpChoice.selectedPump, selectedPumpDetail = pumpChoice.selectedPumpDetail, onSelectNozzleSize = pumpChoice.onSelectNozzleSize, onSelectEjectorCount = pumpChoice.onSelectEjectorCount, onSelectVariant = pumpChoice.onSelectVariant;
    var columns = [
        {
            header: t("sidebar.edit_pump.nozzle"),
            options: nozzleSizes.map(function (_a) {
                var value = _a.value, label = _a.label;
                return ({
                    label: label,
                    isSelected: value === (selected === null || selected === void 0 ? void 0 : selected.nozzleSize),
                    onSelect: function () { return onSelectNozzleSize(value); },
                });
            }),
        },
        {
            header: t("sidebar.edit_pump.size"),
            options: ejectorCounts.map(function (_a) {
                var value = _a.value, label = _a.label;
                return ({
                    label: label,
                    isSelected: value === (selected === null || selected === void 0 ? void 0 : selected.ejectorCount),
                    onSelect: function () { return onSelectEjectorCount(value); },
                });
            }),
        },
    ];
    if (hasVariantColumn) {
        columns.push({
            header: t("sidebar.edit_pump.features"),
            /* Each of these is a pump, so it is named as one, e.g. "SX12 x1 ES". */
            options: variants.map(function (_a) {
                var value = _a.value, label = _a.label, pumpLabel = _a.pumpLabel;
                return ({
                    label: label !== null && label !== void 0 ? label : t("sidebar.edit_pump.no_features"),
                    name: pumpLabel,
                    isSelected: value === (selected === null || selected === void 0 ? void 0 : selected.pump),
                    onSelect: function () { return onSelectVariant(value); },
                });
            }),
        });
    }
    return (_jsx(ChoiceColumns, { columns: columns, thumbnail: selectedPump === null || selectedPump === void 0 ? void 0 : selectedPump.image, summary: selectedPump &&
            selected && (_jsxs(_Fragment, { children: [_jsxs(Styled.SummaryName, { children: [selectedPump.label, !selectedPump.valid && (_jsx(TooltipPortal, { toggleEvent: "hover", placement: "top", anchorElement: _jsx(Styled.SummaryWarning, { role: "img", "aria-label": t("node_warnings.invalid_pump"), children: _jsx(AlertIcon, { size: 16 }) }), children: _jsx(Tooltip, { color: "neutral", children: _jsx(Styled.SummaryWarningText, { children: t("node_warnings.invalid_pump") }) }) }))] }), selectedPumpDetail && (_jsxs(Styled.SummaryDetail, { children: [_jsx(PressureGaugeIcon, { size: "1em" }), selectedPumpDetail, " ", feedPressureUnit] }))] })) }));
};
